module.exports = __webpack_public_path__ + "static/media/web-view1.4265fd89.png";